import {AxiosResponse} from 'axios'
import {corporateApi} from '../../../../setup/axios/CorporateApi'
import {ApiResponse, PageResponse} from '../../../../shared/models/ApiModels'

const API_URL = (process.env.REACT_APP_API_URL || '/').replace(/\/?$/, '/')
const DOCUMENT_URL = `${API_URL}api/v1/document/`

export interface IDocumentModel {
  id: string
  fileName: string
  contentType: string
  size: number
  category: 'LOGO' | 'HEADER' | 'CV'
  createdDate?: string
}

/** CV gizli dosyadır; oturumla alınır (doğrudan link verilemez) */
export async function fetchDocument(documentId: string, fallbackName = 'cv'): Promise<{blob: Blob; fileName: string}> {
  const response = await corporateApi.get(`${DOCUMENT_URL}download/${documentId}`, {responseType: 'blob'})
  const disposition: string = response.headers['content-disposition'] || ''
  const encodedName = /filename\*=UTF-8''([^;]+)/i.exec(disposition)?.[1]
  const plainName = /filename="?([^";]+)"?/i.exec(disposition)?.[1]
  const fileName = encodedName ? decodeURIComponent(encodedName) : plainName || fallbackName
  return {blob: response.data, fileName}
}

/** Dosyayı tarayıcıda indirir */
export async function downloadDocument(documentId: string, fallbackName = 'cv') {
  const {blob, fileName} = await fetchDocument(documentId, fallbackName)
  const url = URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.download = fileName
  document.body.appendChild(link)
  link.click()
  link.remove()
  URL.revokeObjectURL(url)
}

export function loadUnlinkedCvs(
  page = 0,
  size = 10
): Promise<AxiosResponse<ApiResponse<PageResponse<IDocumentModel>>>> {
  return corporateApi.get(`${DOCUMENT_URL}unlinked-cv/search`, {params: {page, size}})
}

export function deleteUnlinkedCv(documentId: string) {
  return corporateApi.delete(`${DOCUMENT_URL}unlinked-cv/delete/${documentId}`)
}

export const formatFileSize = (bytes: number) =>
  bytes < 1024 * 1024 ? `${Math.ceil(bytes / 1024)} KB` : `${(bytes / 1024 / 1024).toFixed(1)} MB`

export const formatDateTime = (value?: string | null) =>
  value
    ? new Date(value).toLocaleString('tr-TR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
      })
    : '-'
